registerComponent("modals/modal-investir", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * 393 linhas viraram estas. Tudo que era jQuery Validate, jquery.mask e `$.post`
 * está em `Asa.formulario`; aqui fica só o que é deste modal — os três passos,
 * a lista de plataformas e as duas telas de desfecho.
 *
 * ── O par emissor/ouvinte ──────────────────────────────────────────────────
 *
 * O `$component.on('open', function (e, atributes))` de 2020 vira
 * `addEventListener('open', (evento) => evento.detail)`. Os dois emissores —
 * `blocks/card-product` (5d) e `pages/product-internal` (8a) — montam o mesmo
 * `detail` com `Asa.legado.dado()`, que devolve NÚMERO onde o `.data()` do
 * jQuery devolvia número: `minAplication` vai direto a um `toLocaleString(…,
 * { style: 'currency' })` e `platforms` é iterado com `forEach`. Ler o
 * `arguments[1]` do jQuery aqui abriria o modal vazio, sem erro nenhum, e só os
 * `toLocaleString` de `undefined` estourariam.
 *
 * ── Os dois passos e o botão que NÃO é o de envio ──────────────────────────
 *
 * `.step-one` (objetivo + valor) → `.btn-ok` → `.step-platforms` (valor < 50 mil)
 * ou `.step-two` (contato) → `[type="submit"]`. O `.btn-ok` NÃO tem `type` no
 * Blade, então para o HTML ele é um botão de envio — e é o botão PADRÃO do
 * formulário. Quem o segura é o `preventDefault()` do clique, como em 2020. O
 * `Asa.formulario` não o enxerga: ele procura `[type="submit"]` literal, que só
 * o `.btn-send` tem. Travar e destravar o `.btn-ok` é trabalho deste arquivo; o
 * `.btn-send` é o `habilitarEnvio` abaixo.
 *
 * ⚠️ `Asa.formulario` ignora campo escondido (o `ignore: ":hidden"` do jQuery
 * Validate — ver `visivel()` em `asa.js`), e é o que faz os dois passos
 * fecharem: no passo 2 o `valueInvest`, que é `required` no markup, já não está
 * à vista.
 *
 * ── O que MUDA de comportamento, e por quê ─────────────────────────────────
 *
 * · **O envio manda `Accept: application/json`** (é `Asa.formulario` quem
 *   manda, e não é opção) e `redirect: 'manual'`. A rota de destino é a página
 *   do fundo (`POST /asset-management/{cat}/{prod}`), que é do contrato
 *   `redirect`: responde 302 mesmo com o cabeçalho. O `$.post` com
 *   `dataType: 'json'` de 2020 caía no `.fail()` por acidente (engasgava no
 *   HTML do redirect); agora cai no caminho de erro de propósito, e um 422
 *   passa a virar mensagem POR CAMPO em vez de tela de erro genérica.
 * · `keyup` → `input` nos campos (ver `blocks/input`).
 * · O `if (form.numberOfInvalids() > 0) { $form.valid(); }` do `checkStep` de
 *   2020 NÃO foi reproduzido: ele revalidava o formulário INTEIRO a cada tecla
 *   depois do primeiro erro, marcando campos em que a pessoa ainda não tinha
 *   tocado. O `Asa.formulario` já revalida, sozinho, todo campo JÁ marcado a
 *   cada `input`, que é o efeito útil; e o `validarTudo()` daqui moveria o foco
 *   para o primeiro inválido no meio da digitação. O portão do passo continua
 *   contando os inválidos, por `[aria-invalid]`, que é o `this.invalid` do
 *   validador.
 *
 * ── O que NÃO muda ─────────────────────────────────────────────────────────
 *
 * O corpo do POST: nomes, e valores MASCARADOS (`#.##0,00` no valor, telefone
 * brasileiro), que é o que o `$form.serialize()` mandava. O `dataLayer.push` da
 * plataforma parceira sai com as mesmas quatro chaves e SEM passar por
 * `Asa.rastrear` — ele não normaliza `eventCategory` nem `eventLabel`, e o
 * legado mandava os dois crus.
 */

const isEn = (document.documentElement.lang || '').toLowerCase().startsWith('en');
const isPt = !isEn;

const form = component.querySelector('.form');
const botaoFechar = component.querySelector('.btn-close');
const botaoOk = component.querySelector('.btn-ok');
const telaSucesso = component.querySelector('.success-screen');
const telaErro = component.querySelector('.error-screen');

const passoUm = component.querySelector('.step-one');
const passoDois = component.querySelector('.step-two');
const passoPlataformas = component.querySelector('.step-platforms');
const listaDePlataformas = component.querySelector('.platforms-list');

const campoValor = form.querySelector('[name="valueInvest"]');
const campoTelefone = form.querySelector('[name="phoneData"]');
const campoFundo = form.querySelector('[name="fund"]');

const numeroAdicional = component.querySelector('.aditional-aplication');
const numeroMinimo = component.querySelector('.min-aplication');
const saldoMinimo = component.querySelector('.min-balance');
const tituloDoFundo = component.querySelector('.title-modal .title-grey');

let passo = 1;
let aplicacaoMinima;

/*
 | ⚠️ `display: block`, não `''`, nas quatro telas que a FOLHA nasce escondendo
 | (`.step-platforms`, `.step-two`, `.success-screen`, `.error-screen`): o
 | `.show()` do jQuery caía no display padrão da tag, que para uma `div` é
 | `block`. Devolver `''` devolveria o `none` da folha e a tela não apareceria,
 | sem erro nenhum no console — a correção 67, de novo. A `.step-one` e o
 | `<form>` saem de display da folha e voltam para ele: ali `''` é o certo,
 | porque foi o JS que escreveu o `none`.
 */
const mostrar = (el, visivel) => {
    if (el) {
        el.style.display = visivel ? 'block' : 'none';
    }
};

/** O `numberOfInvalids()` do validador: os campos que JÁ mostraram erro. */
const semInvalidos = () => form.querySelectorAll('[aria-invalid="true"]').length === 0;

/*
 | O `checkStep(form)` de 2020, nas duas metades que ele tinha: o `.btn-ok` no
 | passo 1 e o `.btn-send` no passo 2. O `Asa.formulario` chama esta função toda
 | vez que reavalia o envio — no boot, a cada `input`, a cada `blur` —, e ela
 | devolve se o `[type="submit"]` pode destravar.
 */
const habilitarEnvio = () => {
    if (passo === 1) {
        const objetivoMarcado = form.querySelectorAll('[name="objective"]:checked').length > 0;
        const valorPreenchido = Boolean(campoValor.value);

        botaoOk.disabled = !(objetivoMarcado && valorPreenchido && semInvalidos());

        // No passo 1 o envio fica travado, como em 2020: o `checkStep` só
        // tocava no `.btn-send` quando `step === 2`, e ele nasce `disabled` no
        // Blade.
        return false;
    }

    const preenchidos = ['nameData', 'phoneData', 'emailData']
        .every((nome) => Boolean(form.querySelector(`[name="${nome}"]`).value));

    return preenchidos && semInvalidos();
};

/*
 | A máscara do telefone, a mesma dos outros formulários de 2020.
 |
 | PT: 11 dígitos viram `(00) 00000-0000`, menos do que isso fica em
 | `(00) 0000-00009`. EN: o telefone estrangeiro não tem formato fixo, e 2020 só
 | filtrava os não dígitos em tempo real — uma máscara de N tokens `0` é
 | exatamente esse filtro dentro do mesmo contrato.
 */
const mascaraDoTelefone = isPt
    ? (valor) => (valor.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009')
    : (valor) => '0'.repeat(Math.max(1, valor.replace(/\D/g, '').length));

if (campoTelefone && isEn) {
    campoTelefone.setAttribute('inputmode', 'numeric');
}

/*
 | ⚠️ `nameData`, `phoneData` e `emailData` ganham `required` AQUI, e não no
 | Blade (que não muda nesta reescrita): eram `rules: { …: { required: true } }`
 | do jQuery Validate, e sem o atributo o `valueMissing` nunca dispara — sair de
 | um campo vazio deixaria de mostrar "Este campo é obrigatório.", que é o que
 | 2020 mostrava.
 |
 | Os três `objective` NÃO ganham: `blocks/check` renderiza `type="checkbox"`, e
 | `required` num checkbox vale POR CAIXA, não pelo grupo — marcar uma deixaria
 | as outras duas inválidas. O `required: true` de grupo do jQuery Validate não
 | tem equivalente em HTML; quem o reproduz é o `habilitarEnvio` acima, que é
 | onde o `checkStep` de 2020 também o reproduzia.
 */
['nameData', 'phoneData', 'emailData'].forEach((nome) => {
    const campo = form.querySelector(`[name="${nome}"]`);

    if (campo) {
        campo.required = true;
    }
});

const formulario = Asa.formulario(form, {
    regras: {
        valueInvest: {
            // O `addMethod('currency')` de 2020: o valor mascarado tem de
            // alcançar a aplicação mínima DO FUNDO, que só chega no `open`.
            minimo: () => aplicacaoMinima,
        },
        emailData: {
            email: true,
        },
        phoneData: {
            minlength: 7,
            // `cellphone: (isPt) ? true : false` — DDD e o 9 na frente são
            // regra brasileira e só valem em pt.
            celular: isPt,
        },
    },
    mascaras: {
        valueInvest: '#.##0,00',
        phoneData: mascaraDoTelefone,
    },
    habilitarEnvio,
});

/* ── Abrir ──────────────────────────────────────────────────────────────── */

/* Tagueamento (plano v3.1): o fundo em slug (o fim do `data-product-url`), quando
   o modal abriu e como vai fechar. O `form_*` e o `generate_lead` saem do
   `tracking.js`, pelo `data-track-form` do `<form>`; o fundo e a faixa de valor
   vão nos `data-track-*` dele, escritos aqui. */
let abertoEm = 0;
const fundoEmSlug = (url) => String(url || '').split(/[?#]/)[0].split('/').filter(Boolean).pop() || '';
const origemDoModal = () => ((window.AsaTracking && window.AsaTracking.context && window.AsaTracking.context.page_type) === 'fund' ? 'fund_page' : 'fund_list');

component.addEventListener('open', function (evento) {
    const {
        aditionalAplication,
        minAplication,
        minBalance,
        platforms,
        productName,
        productUrl,
        isInstitucional,
    } = evento.detail;

    /*
     | O `$.post(formActionUrl || window.location.href, …)` de 2020. O
     | `Asa.formulario` lê `form.getAttribute('action')` na hora do envio, e o
     | padrão dele quando não há `action` é o `<base href>`, não a página atual
     | — daí escrever o destino aqui, com o mesmo `||` do legado.
     */
    form.setAttribute('action', productUrl || window.location.href);

    abertoEm = Date.now();
    form.dataset.trackFundName = fundoEmSlug(productUrl);
    delete form.dataset.trackAmountBucket;
    Asa.track('modal_open', { modal_name: 'quero_investir', origin: origemDoModal(), method: 'click', fund_name: form.dataset.trackFundName });

    /*
     | Nome do fundo, título e URL das plataformas vêm do CMS: entram como TEXTO
     | e atributo, nunca como HTML. Eram `innerHTML` e template string — um nome
     | com `<img onerror>` ou uma URL com `">` virava script no modal (achado A1
     | do QA de produtos, 13/10/2026). O servidor já só manda URL http(s); o
     | teste aqui é a segunda trava.
     */
    campoFundo.value = productName;
    tituloDoFundo.textContent = productName;

    aplicacaoMinima = minAplication;

    if (platforms) {
        listaDePlataformas.textContent = '';

        platforms.forEach(function (plataforma) {
            const url = String((plataforma.link && plataforma.link.url) || '');
            const titulo = String(plataforma.title || '');

            if (!/^https?:\/\//i.test(url)) {
                return;
            }

            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.dataset.track = 'platform_click';
            link.dataset.trackPlatform = Asa.slug(titulo).replace(/[\s-]+/g, '_');
            link.dataset.trackOrigin = 'modal_investir';
            link.dataset.trackFundName = form.dataset.trackFundName || '';

            const nome = document.createElement('span');
            nome.textContent = titulo;
            link.appendChild(nome);

            // O ícone é fixo, sem dado do CMS.
            link.insertAdjacentHTML('beforeend', '<svg class="svg-arrow-right"><use xlink:href="#svg-arrow-right" xlink:title="Acessar" /></svg>');

            listaDePlataformas.appendChild(link);
        });
    }

    // `pt-br` fixo nos três, como em 2020: são valores em reais, e a página em
    // inglês mostrava BRL também.
    const emReais = (valor) => valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

    numeroAdicional.innerHTML = emReais(aditionalAplication);
    numeroMinimo.innerHTML = emReais(minAplication);
    saldoMinimo.innerHTML = emReais(minBalance);

    component.classList.add('active');
    document.body.classList.add('modal-opened');

    if (isInstitucional) {
        component.classList.add('institucional');
        mostrar(passoPlataformas, false);
        passoUm.style.display = 'none';

        mostrar(passoDois, true);
        passo += 1;
    }

    formulario.atualizarEnvio();
});

/* ── Fechar ─────────────────────────────────────────────────────────────── */

const fechar = (metodo = 'x') => {
    if (component.classList.contains('active')) {
        Asa.track('modal_close', { modal_name: 'quero_investir', method: metodo, seconds: Math.round((Date.now() - abertoEm) / 1000) });
    }

    document.body.classList.remove('modal-opened');
    component.classList.remove('active');

    passoUm.style.display = '';
    mostrar(passoPlataformas, false);
    mostrar(passoDois, false);

    mostrar(telaSucesso, false);
    mostrar(telaErro, false);
    form.style.display = '';

    form.reset();
    formulario.limpar();

    /*
     | Volta ao passo inicial e re-trava os dois botões. `form.reset()` não
     | dispara `change` nos checkboxes em todo navegador — sem o
     | `atualizarEnvio()` explícito o `habilitarEnvio` não recomputaria e o
     | `.btn-ok` ficaria habilitado sobre um formulário recém-zerado.
     |
     | ⚠️ A classe `.institucional` NÃO sai, como em 2020: quem abriu o modal
     | institucional uma vez continua vendo a caixa "informe os dados abaixo"
     | nos fundos seguintes, e a de "já é um cliente?" fica escondida. É defeito
     | de produção, reproduzido à letra e registrado no relatório — corrigi-lo
     | aqui mudaria a tela sem decisão do responsável.
     */
    passo = 1;
    botaoOk.disabled = true;
    formulario.atualizarEnvio();
};

botaoFechar.addEventListener('click', () => fechar('x'));

component.querySelectorAll('.link-error, .link-success').forEach(function (link) {
    link.addEventListener('click', function (evento) {
        evento.preventDefault();
        fechar('back_link');
    });
});

/* ── Plataformas parceiras ──────────────────────────────────────────────── */

listaDePlataformas.addEventListener('click', function (evento) {
    const link = evento.target.closest('a');

    if (!link) {
        return;
    }

    /*
     | O `eventCategory` vem do botão que abriu o modal, achado pelo nome do
     | fundo — é o `data-track-category` que o `track()` do Blade escreve.
     |
     | ⚠️ `dataLayer.push` direto, e não `Asa.rastrear`: o helper normaliza as
     | quatro chaves com `slug()`, e o legado mandava `eventCategory` e
     | `eventLabel` crus. Tracking é contrato (regra 7 do programa).
     */
    const botaoDoFundo = document.querySelector(`[data-open-modal][data-product-name="${campoFundo.value}"]`);
    const categoria = botaoDoFundo ? Asa.legado.dado(botaoDoFundo, 'track-category') : undefined;
    // `slugfy(...).replace('-', '_')` SEM `g`: só a primeira ocorrência, como
    // em 2020.
    const nome = Asa.slug(link.querySelector('span').textContent).replace('-', '_');

    window.dataLayer.push({
        event: 'gaEvent',
        eventAction: `plataformas_parceiras-${nome}`,
        eventCategory: categoria,
        eventLabel: window.trackLabel,
        eventName: 'investir_fundo-asa',
    });

    passo += 1;
});

/* ── O objetivo do passo 1 ──────────────────────────────────────────────── */

form.addEventListener('change', function (evento) {
    const caixa = evento.target;

    if (caixa instanceof HTMLInputElement && caixa.name === 'objective' && caixa.checked) {
        Asa.track('invest_step', { step: 'objective_selected', target_id: caixa.value, fund_name: form.dataset.trackFundName });
    }
});

/* ── O "Ok" do passo 1 ──────────────────────────────────────────────────── */

botaoOk.addEventListener('click', function (evento) {
    evento.preventDefault();

    mostrar(passoPlataformas, false);
    passoUm.style.display = 'none';
    mostrar(passoDois, false);

    /*
     | ⚠️ `replaceAll('.', '')` e `parseInt`, exatamente como 2020: a máscara
     | `#.##0,00` escreve "50.000,00" e a conta despreza a vírgula — o inteiro
     | é 50000. Uma máscara com outro separador de milhar mudaria o passo
     | escolhido (plataformas em vez de contato) sem erro nenhum.
     */
    if (parseInt(campoValor.value.replaceAll('.', ''), 10) < 50000) {
        mostrar(passoPlataformas, true);
    } else {
        mostrar(passoDois, true);
    }

    // A faixa, nunca o valor.
    const faixa = parseInt(campoValor.value.replaceAll('.', ''), 10) < 50000 ? 'under_50k' : 'over_50k';

    form.dataset.trackAmountBucket = faixa;
    Asa.track('invest_step', { step: 'amount_submitted', amount_bucket: faixa, fund_name: form.dataset.trackFundName });
    Asa.track('invest_step', { step: faixa === 'under_50k' ? 'platforms_shown' : 'contact_shown', amount_bucket: faixa, fund_name: form.dataset.trackFundName });

    // O evento do clique vem dos data-track-* do próprio botão
    // (quero-investir-ok / quero-investir / clique), via tracking.js.
    passo += 1;
    formulario.atualizarEnvio();
});

/* ── Envio ──────────────────────────────────────────────────────────────── */

form.addEventListener('formulario:enviando', function () {
    // Disparado aqui (e não por data-track-* no botão) para contar só os envios
    // que passaram na validação — é o `remoteTrack` do `submitHandler` de 2020.
    Asa.rastrear('quero-investir', 'clique', null, 'quero-investir-enviar');
});

form.addEventListener('formulario:sucesso', function () {
    form.style.display = 'none';
    mostrar(telaSucesso, true);
});

form.addEventListener('formulario:erro', /** @param {CustomEvent} evento */ function (evento) {
    /*
     | 422 com erros por campo não troca de tela — mesma decisão do 5c: as
     | mensagens já estão nas `label.error`, ao lado do campo que as causou, e
     | esconder o formulário esconderia justamente a informação nova. A tela de
     | erro continua valendo para tudo o mais, inclusive o 302 que esta rota
     | devolve hoje, que é onde o `.fail()` de 2020 caía.
     */
    if (evento.detail && evento.detail.erros) {
        return;
    }

    form.style.display = 'none';
    mostrar(telaSucesso, false);
    mostrar(telaErro, true);
});

});
